
import { Component, Prop, Vue } from 'vue-property-decorator';
import UnderlineForm from "@/components/utils/PopulateForms/components/UnderlineForm.vue";
import CheckBox from "@/components/utils/PopulateForms/components/CheckBox.vue";
import { schedule8DataInfoType } from '@/types/Application/ReplyFamilyLawMatter/Pdf';
import { disagreeCancellationReasonListInfoType } from '@/types/Application/ReplyFamilyLawMatter/GuardianShip';

@Component({
    components:{
        UnderlineForm,
        CheckBox
    }
})

export default class Schedule8 extends Vue {

    @Prop({required:true})
    result!: any;
   
    dataReady = false;
    guardInfo = {} as schedule8DataInfoType;
   
    mounted(){
        this.dataReady = false;       
        this.guardInfo = this.getGuardianshipOfChildInfo();       
        this.dataReady = true;      
    } 

    public getGuardianshipOfChildInfo(){
        let guardianshipInfo = {} as schedule8DataInfoType;

        guardianshipInfo = {
            ableGuardian: false,
            ableGuardianDesc: '',
            suitableGuardian: false,
            suitableGuardianDesc: '',
            noConsent: false,
            noConsentDesc: '',
            other: false,
            otherDesc: '',
            bstIntrst: ''
        }
        
        if (this.result.disagreeCancellingGuardianOfChildSurvey?.disagreeReasonList && this.result.disagreeCancellingGuardianOfChildSurvey?.childBestInterestReason){
            const disagreeReasons: disagreeCancellationReasonListInfoType = this.result.disagreeCancellingGuardianOfChildSurvey.disagreeReasonList;           
            guardianshipInfo = {
                ableGuardian: disagreeReasons.checked.includes('able'),
                ableGuardianDesc: (disagreeReasons.checked.includes('able') && disagreeReasons.ableComment)?disagreeReasons.ableComment:'',
                suitableGuardian: disagreeReasons.checked.includes('suitable'),
                suitableGuardianDesc: (disagreeReasons.checked.includes('suitable') && disagreeReasons.suitableComment)?disagreeReasons.suitableComment:'',
                noConsent: disagreeReasons.checked.includes('noConsent'),
                noConsentDesc: (disagreeReasons.checked.includes('noConsent') && disagreeReasons.noConsentComment)?disagreeReasons.noConsentComment:'',
                other: disagreeReasons.checked.includes('other'),
                otherDesc: (disagreeReasons.checked.includes('other') && disagreeReasons.otherComment)?disagreeReasons.otherComment:'',
                bstIntrst: this.result.disagreeCancellingGuardianOfChildSurvey?.childBestInterestReason?this.result.disagreeCancellingGuardianOfChildSurvey.childBestInterestReason:''
            }
        }
        
        return guardianshipInfo;
    }
}
